module.exports = __webpack_public_path__ + "img/chapter__10_image_2.3d9018c6.jpg";